// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___IOUf","title":"styles_title__2jKzl"};